import { END_POINTS } from "../constants/url";
import { Category, Sub_Category } from "../types/General";
import { CATEGORY_TYPE } from "../utils/enums";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRatings: builder.query<
      CommonResponseType,
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.rating}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),

    deleteRatingsId: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.rating}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const { useDeleteRatingsIdMutation, useLazyGetRatingsQuery } =
  categoryApi;
